module.exports = {"130424100":"成安镇","130424101":"商城镇","130424102":"漳河店镇","130424103":"李家疃镇","130424104":"北乡义镇","130424105":"道东堡镇","130424200":"辛义乡","130424201":"柏寺营乡","130424204":"长巷乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130424.json
// module id = 202
// module chunks = 0